import { render, staticRenderFns } from "./Safra.vue?vue&type=template&id=a2187820"
import script from "./Safra.vue?vue&type=script&lang=js"
export * from "./Safra.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports